// Lead status constants
// Single source of truth for lead pipeline stages

export const LEAD_STATUSES = ['Open', 'Quoted', 'Won', 'Lost'];

// Lead stages
export const LEAD_STAGES = ['Cold', 'Warm', 'Hot'];

// Statuses that represent active pipeline (shown in main list)
export const ACTIVE_STATUSES = ['Open', 'Quoted'];

// Statuses that represent closed deals (hidden from main list)
export const CLOSED_STATUSES = ['Won', 'Lost'];

// Status that triggers project creation
export const WON_STATUS = 'Won';

// Status colors for UI
export const STATUS_COLORS = {
  Open: '#f59e0b',    // Amber
  Quoted: '#3b82f6',  // Blue
  Won: '#22c55e',     // Green
  Lost: '#ef4444'     // Red
};

// Stage colors for UI
export const STAGE_COLORS = {
  Cold: '#94a3b8',    // Slate
  Warm: '#fb923c',    // Orange
  Hot: '#dc2626'      // Red
};

// Helper to check if a status is active
export const isActiveStatus = (status) => 
  ACTIVE_STATUSES.includes(status) || 
  ACTIVE_STATUSES.map(s => s.toLowerCase()).includes(status?.toLowerCase());

// Helper to check if a status is closed
export const isClosedStatus = (status) => 
  CLOSED_STATUSES.includes(status) || 
  CLOSED_STATUSES.map(s => s.toLowerCase()).includes(status?.toLowerCase());

// Helper to get status color
export const getStatusColor = (status) => 
  STATUS_COLORS[status] || STATUS_COLORS.Open;

// Helper to get stage color
export const getStageColor = (stage) => 
  STAGE_COLORS[stage] || STAGE_COLORS.Cold;
